import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const updateQuickLookModalSelector = createSelector(testTargetOffersSelector, offers => offers.updateQuickLookModal || Empty.Object);

export { updateQuickLookModalSelector };
